'use strict';

/**
 * @ngdoc service
 * @name gfcmsApp.response.service
 * @description
 * # response.service
 * Service in the gfcmsApp.
 */
angular.module('gfcmsApp')
  .service('BaseService', function($http, $q, appSettings, errorService) {

    function BaseService(name) {
      this.name = name;
      this.http = $http;
      this.q = $q;
      this.baseUrl = appSettings.api.baseUrl + appSettings.api.version;
    }

    BaseService.prototype.requestSuccess = requestSuccess;
    BaseService.prototype.requestFailure = requestFailure;
    BaseService.prototype.handleSuccess = handleSuccess;
    BaseService.prototype.handleError = handleError;

    function requestSuccess(response)
    {
        return response.data;
    }

    function requestFailure(error)
    {
        return $q.reject(errorService.handleError(error));
    }

    function handleSuccess(response) {
     return response.data;
    }

    function handleError(error) {
      return $q.reject(errorService.handleError(error));
    }

    return BaseService;
  });
